<div id="Login_section">
  <section class="singUp-area section-py-120">
    <div class="container">
      <!-- Warning Banner for Invoice Redirect -->
      <div class="row justify-content-center" *ngIf="showInvoiceWarning">
        <div class="col-xl-8 col-lg-10">
          <div
            class="alert alert-warning d-flex align-items-center mb-4"
            role="alert"
          >
            <i
              class="fas fa-exclamation-triangle me-3"
              style="font-size: 1.5rem"
            ></i>
            <div>
              <strong>Login Required!</strong> Please login to submit an
              invoice. You were redirected here because invoice submission
              requires authentication.
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8">
          <div class="singUp-wrap">
            <form
              novalidate
              [formGroup]="form"
              class="form-horizontal account__form"
            >
              <div class="form-grp">
                <label class="inline"
                  >Email <span class="text-danger">*</span></label
                >
                <div
                  class="form-group"
                  [ngClass]="{ 'has-error ': !f['Email'].valid && submitted }"
                >
                  <input
                    type="email"
                    class="form-control"
                    formControlName="Email"
                    placeholder="Enter your Email"
                  />
                </div>
              </div>
              <div class="form-grp">
                <label class="inline"
                  >Password <span class="text-danger">*</span></label
                >
                <div
                  class="form-grp"
                  [ngClass]="{
                    'has-error ': !f['Password'].valid && submitted,
                  }"
                >
                  <div class="input-group">
                    <input
                      [type]="Visible ? 'text' : 'password'"
                      class="form-control"
                      formControlName="Password"
                      placeholder="Enter your password"
                    />
                    <button
                      type="button"
                      (click)="toggleVisibility()"
                      class="input-group-text"
                      style="border: none; background: transparent"
                    >
                      <i
                        [ngClass]="Visible ? 'fa fa-eye-slash' : 'fa fa-eye'"
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="account__check">
                <div class="account__check-remember"></div>
                <div class="account__check-forgot">
                  <a href="/vendor-forgot-password">Forgot Password?</a>
                </div>
              </div>
              <button class="btn btn-two arrow-btn" (click)="onLogin()">
                Sign In<img
                  src="assets/img/icons/right_arrow.svg"
                  alt="img"
                  class="injectable"
                />
              </button>
            </form>
            <div class="account__switch">
              <p>Don't have an account?<a href="/vendor-sign-up">Sign Up</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
